"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import cx from "classnames";
import AutoFocusOnMount from "../../utils/AutoFocusOnMount.mjs";
const Prompt = (props) => {
  const {
    className,
    titleId,
    header,
    prefix = "",
    children,
    open = false,
    closeBtnClick,
    title,
    footer,
    describedById,
    contentAttributes,
    ...other
  } = props;
  const classes = cx(
    `${prefix}prompt`,
    open ? `${prefix}prompt--enter` : `${prefix}prompt--close`,
    className
  );
  const hookedHeader = header ? React.cloneElement(header, { closeBtnClick, prefix, backBtnClick: null }) : null;
  const hookedFooter = footer && React.cloneElement(footer, { prefix, closeBtnClick }) || null;
  const [wrapperFocus, contentRef] = AutoFocusOnMount();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "aria-describedby": describedById,
      "aria-labelledby": titleId,
      ...other,
      className: classes,
      "aria-modal": "true",
      role: "dialog",
      tabIndex: -1,
      children: [
        wrapperFocus !== void 0 && hookedHeader,
        /* @__PURE__ */ jsxs("div", { className: `${prefix}prompt__content-wrapper`, children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              ref: contentRef,
              "data-autofocus": wrapperFocus,
              tabIndex: 0,
              role: "document",
              ...contentAttributes,
              className: `${prefix}prompt__content`,
              children: [
                /* @__PURE__ */ jsx("h2", { id: titleId, className: `${prefix}prompt__heading`, children: title }),
                children
              ]
            }
          ),
          hookedFooter
        ] })
      ]
    }
  );
};
var Prompt_default = Prompt;
export {
  Prompt,
  Prompt_default as default
};
